import React from 'react';
import styles from './NavMenu.module.css';
import { useLocation } from 'react-router-dom';

import { ReactComponent as HomeIcon} from '../../assets/navbar/Home.svg'
import { ReactComponent as FriendsIcon} from '../../assets/navbar/Friends.svg'
import { ReactComponent as InventoryIcon} from '../../assets/navbar/Invetory.svg'
import { ReactComponent as RaffleIcon} from '../../assets/navbar/Raffle.svg'
import { ReactComponent as TasksIcon} from '../../assets/navbar/Tasks.svg'

import { useTelegram } from '../../app/providers/TelegramProvider';
import { useRouteTransition } from '../../app/providers/TransitionProvider';
import { useNavMenuStore } from '../../store/useNavMenuStore';

interface NavMenuProps {
  onRaffleOpen?: () => void;
}

const NavMenu: React.FC<NavMenuProps> = ({ onRaffleOpen }) => {
  const tg = window.Telegram?.WebApp;
  const location = useLocation();
  const { isVisible } = useNavMenuStore();
  const { startTransition } = useRouteTransition();
  // const { systemInsets, contentInsets } = useTelegram();

  const isTabActive = (path: string) => location.pathname === path;
  const isTabBlocked = (path: string) => false;

  if (!isVisible) return null;

  const handleTabClick = (path: string) => (e: React.MouseEvent) => {
    if (tg?.HapticFeedback) {
      tg.HapticFeedback.impactOccurred('medium');
    }

    if (path === '/raffles' && onRaffleOpen) {
      onRaffleOpen();
      return;
    }

    if (isTabBlocked(path)) {
      e.preventDefault();
      return;
    }

    startTransition(path);
  };

  return (
    <>
      <div className={styles.navMenu}>
        <div className={styles.navMenu__content}>
          <button
            className={`${styles.navMenu__item} ${
              isTabActive('/profile') ? styles['navMenu__item--active'] : ''
            } ${
              isTabBlocked('/profile')
                ? styles['navMenu__item--blocked']
                : ''
            }`}
            onClick={handleTabClick('/profile')}
          >
            <InventoryIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Инвентарь</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${
              isTabActive('/friends') ? styles['navMenu__item--active'] : ''
            } ${
              isTabBlocked('/friends') ? styles['navMenu__item--blocked'] : ''
            }`}
            onClick={handleTabClick('/friends')}
          >
            <FriendsIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Друзья</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${
              isTabActive('/') ? styles['navMenu__item--active'] : ''
            } ${isTabBlocked('/') ? styles['navMenu__item--blocked'] : ''}`}
            onClick={handleTabClick('/')}
          >
            <HomeIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Главная</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${
              isTabActive('/tasks') ? styles['navMenu__item--active'] : ''
            } ${
              isTabBlocked('/tasks') ? styles['navMenu__item--blocked'] : ''
            }`}
            onClick={handleTabClick('/tasks')}
          >
            <TasksIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Задания</span>
          </button>
          <button
            className={`${styles.navMenu__item} ${
              isTabActive('/giveway') ? styles['navMenu__item--active'] : ''
            } ${
              isTabBlocked('/giveway') ? styles['navMenu__item--blocked'] : ''
            }`}
            onClick={handleTabClick('/giveway')}
          >
            <RaffleIcon className={styles.navMenu__icon} />
            <span className={styles.navMenu__text}>Розыгрыши</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NavMenu;
